<section class="app-newsletter">
  <div class="container app-newsletter__con">
    <div class="app-newsletter__con__lef">
      <img
        class="app-newsletter__con__lef__img"
        [priority]="true"
        alt="background"
        ngSrc="assets/images/newsletter-section-banner.webp"
        width="732"
        height="534"
      />
    </div>
    <div class="app-newsletter__con__rig">
      <form class="www-form app-newsletter__con__rig__for" [formGroup]="form" novalidate appInvalidControlScroll>
        <p class="app-newsletter__con__rig__for__p">
          Bądź na bieżąco! Z naszego newslettera dowiesz się o nowościach w PRO.CONNECT.
        </p>

        <div class="row">
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="f.firstname"
                [formControlName]="'firstname'"
                id="firstname"
                type="text"
                autocomplete="off"
              />
              <label for="firstname"> Wprowadź swoje imię </label>
            </div>
            <app-validate-message [control]="f.firstname" />
          </div>
          <div class="col-12">
            <div class="group">
              <input
                [appInputValidator]="f.email"
                [formControlName]="'email'"
                id="email"
                type="email"
                autocomplete="off"
              />
              <label for="email"> Wprowadź swój adres e-mail </label>
            </div>
            <app-validate-message [control]="f.email" />
          </div>
          <div class="col-12 my-2">
            <div class="d-xl-flex align-items-center gap-3">
              <label class="radio">
                <input
                  [appInputValidator]="f.barber"
                  [formControlName]="'barber'"
                  [value]="1"
                  name="barber"
                  type="radio"
                />
                <span class="design"></span>
                <span class="text">Jestem fryzjerem</span>
              </label>
              <label class="radio">
                <input
                  [appInputValidator]="f.barber"
                  [formControlName]="'barber'"
                  [value]="0"
                  name="barber"
                  type="radio"
                />
                <span class="design"></span>
                <span class="text">Jestem osobą prywatną</span>
              </label>
            </div>
            <app-validate-message [control]="f.barber" />
          </div>
        </div>

        <p class="app-newsletter__con__rig__for__con">
          Wyrażam zgodę na kontakt przez L’Oréal Polska Sp. z o.o. z siedzibą w Warszawie (00-844 przy ul. Grzybowskiej
          62) w celu marketingu bezpośredniego, w tym przesyłania informacji handlowych, w szczególności przesyłania
          informacji handlowych dotyczących produktów marek (L’Oréal Professionnel, Kérastase, Matrix, Biolage, Redken)
          za pośrednictwem następujących kanałów komunikacji:
        </p>

        <div class="my-lg-3 my-2">
          <div>
            <input type="checkbox" id="agreementEmail" [formControlName]="'agreementEmail'" />
            <label for="agreementEmail">E-mail<sup>*</sup></label>
          </div>
          <app-validate-message [control]="f.agreementEmail" />
        </div>

        <p class="app-newsletter__con__rig__for__info">
          Aby uzyskać więcej informacji o tym, jak wykorzystujemy Twoje dane osobowe zapoznaj się z naszą Polityką
          Prywatności.
        </p>

        <div class="row www-act-acc__btn my-4 my-md-0">
          <div class="col-12 d-flex justify-content-end">
            <button
              (click)="onSave()"
              [disabled]="loading()"
              type="submit"
              class="www-btn www-black-btn d-flex align-items-center gap-2 justify-content-center"
            >
              <span>Zapisz się</span>

              @if (loading()) {
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 200 200">
                  <circle fill="#FFFFFF" stroke="#FFFFFF" stroke-width="14" r="15" cx="40" cy="65">
                    <animate
                      attributeName="cy"
                      calcMode="spline"
                      dur="1"
                      values="65;135;65;"
                      keySplines=".5 0 .5 1;.5 0 .5 1"
                      repeatCount="indefinite"
                      begin="-.4"
                    ></animate>
                  </circle>
                  <circle fill="#FFFFFF" stroke="#FFFFFF" stroke-width="14" r="15" cx="100" cy="65">
                    <animate
                      attributeName="cy"
                      calcMode="spline"
                      dur="1"
                      values="65;135;65;"
                      keySplines=".5 0 .5 1;.5 0 .5 1"
                      repeatCount="indefinite"
                      begin="-.2"
                    ></animate>
                  </circle>
                  <circle fill="#FFFFFF" stroke="#FFFFFF" stroke-width="14" r="15" cx="160" cy="65">
                    <animate
                      attributeName="cy"
                      calcMode="spline"
                      dur="1"
                      values="65;135;65;"
                      keySplines=".5 0 .5 1;.5 0 .5 1"
                      repeatCount="indefinite"
                      begin="0"
                    ></animate>
                  </circle>
                </svg>
              } @else {
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="13.496" height="9.001" viewBox="0 0 13.496 9.001">
                  <path
                    d="M16.482,11.424a.613.613,0,0,0,0,.863l2.85,2.855H8.48a.609.609,0,0,0,0,1.219H19.323l-2.85,2.855a.617.617,0,0,0,0,.863.607.607,0,0,0,.858,0L21.2,16.182h0a.684.684,0,0,0,.127-.192.582.582,0,0,0,.047-.234.611.611,0,0,0-.173-.427l-3.863-3.891A.6.6,0,0,0,16.482,11.424Z"
                    transform="translate(-7.875 -11.251)"
                  />
                </svg> -->
                >
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
